import { useContext } from 'react';
import AnimateHeight from '@/common/AnimateHeight';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import { CommonWrapper } from './FiltersMenu.styles';

export default function Size() {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();

  const show = (appliedFilters.bodyStyles?.length ?? 0) > 0;

  return (
    <AnimateHeight show={show}>
      <FilterDrawer
        testId="facet-size"
        facetContent={facetData.sizeClasses?.buckets}
        facetName="Size"
      >
        <CommonWrapper>
          {facetData.sizeClasses?.buckets?.map(
            ({ count, displayName, key }) => (
              <Checkbox
                facet="sizeClasses"
                filter={key}
                id={`size-${key}`}
                key={key}
                label={
                  showInventoryCounts
                    ? `${displayName} (${count.toLocaleString()})`
                    : displayName
                }
                checked={appliedFilters.sizeClasses?.includes(key)}
                onChange={() =>
                  updateListFilter({
                    filterKey: 'sizeClasses',
                    value: key
                  })
                }
              />
            )
          )}
        </CommonWrapper>
      </FilterDrawer>
    </AnimateHeight>
  );
}
